import { render, staticRenderFns } from "./takeALook.vue?vue&type=template&id=32c1cb38&scoped=true&"
import script from "./takeALook.vue?vue&type=script&lang=js&"
export * from "./takeALook.vue?vue&type=script&lang=js&"
import style0 from "./takeALook.vue?vue&type=style&index=0&id=32c1cb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1cb38",
  null
  
)

export default component.exports